/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import styles from './Quotes.module.css';

const Quotes = () => (
  <div className={styles.main}>
    <p>
      "No human investigation can be called science if it does not pass through mathematical tests"
      -Leonardo Da Vinci.
    </p>

  </div>
);

export default Quotes;
